module.exports = __webpack_public_path__ + "static/media/placas.a122d182.svg";